import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFormType } from "../../redux/actions";
import DynamicForm from "../../components/form/DynamicForm";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import useIsInIframe from "../../hooks/useIsInIframe";

const RefinancePage = () => {
    const isInIframe = useIsInIframe();
    const dispatch = useDispatch();
    const formType = useSelector((state) => state.formType);

    useEffect(() => {
        // Set formType to "refinance" only if it's not already set
        // This preserves the home page flow where formType is set before navigation
        if (!formType) {
            dispatch(setFormType("refinance"));
        }
    }, [dispatch, formType]);
    
    return (
        <div>
            <div className="page-container">
                {!isInIframe && <Navbar />}
                <div className="app">
                    <div className="section">
                        <DynamicForm/>
                    </div>
                </div>
                {!isInIframe && <Footer />}
            </div>
        </div>
    );
};

export default RefinancePage;
